import React from "react";

const CARDS = `${import.meta.env.BASE_URL}img/cards`;

// Reference result-modal checkLowCards / checkHighCards (9SS / 10SS are shown on their own)
const isLow = (c) => {
  if (c === "1" || c === "9SS" || c === "10SS") return false;
  if (c.length === 3) {
    const t = c.slice(0, 1);
    return t.toLowerCase() === "a" || Number(t) <= 9;
  }
  return false;
};
const isHigh = (c) => {
  if (c === "1" || c === "9SS" || c === "10SS") return false;
  if (c.length === 3) return ["j", "k", "q"].includes(c.slice(0, 1).toLowerCase());
  return c.length === 4 && c.slice(0, 2) === "10";
};

/**
 * Reference result body for Casino Meter (cmeter): Low Cards row, High Cards row,
 * the 9♠/10♠ card on the right, and "Winner" rdesc.
 */
export default function CmeterResultBody({ t1 }) {
  const cards = t1?.card ? String(t1.card).split(",") : [];
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const row = (test) =>
    cards.map((c, i) =>
      test(c) ? (
        <div className="casino-result-cards-item" key={i}>
          <img src={`${CARDS}/${c}.png`} className="mr-2" alt="" />
        </div>
      ) : null
    );
  return (
    <div data-btl-result="" className="row row5">
      <div className="col-12 col-lg-9">
        <div className="row align-items-center">
          <div className="col-10">
            <div className="row align-items-center">
              <div className="col-2">
                <b>Low Cards</b>
              </div>{" "}
              <div className="col-10">{row(isLow)}</div>
            </div>{" "}
            <div className="row align-items-center mt-3">
              <div className="col-2">
                <b>High Cards</b>
              </div>{" "}
              <div className="col-10">{row(isHigh)}</div>
            </div>
          </div>{" "}
          <div className="col-2 text-center">
            <div className="casino-result-cards-item">
              {cards.map((c, i) =>
                c === "9SS" || c === "10SS" ? <img key={i} src={`${CARDS}/${c}.png`} className="mr-2" alt="" /> : null
              )}
            </div>
          </div>
        </div>
      </div>{" "}
      <div className="col-12 col-lg-3">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>Winner</div> <div>{desc[0]}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
